module.exports = __webpack_public_path__ + "img/data-file-graph-alternate.f9a1f05d.svg";